import { render, staticRenderFns } from "./CompTabelaCDAEnviadasCRA.vue?vue&type=template&id=24a0e15a&scoped=true&"
import script from "./CompTabelaCDAEnviadasCRA.vue?vue&type=script&lang=js&"
export * from "./CompTabelaCDAEnviadasCRA.vue?vue&type=script&lang=js&"
import style0 from "./CompTabelaCDAEnviadasCRA.vue?vue&type=style&index=0&id=24a0e15a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a0e15a",
  null
  
)

export default component.exports